import { render } from "./RecaptchaCompliance.vue?vue&type=template&id=66062b7e&scoped=true"
import script from "./RecaptchaCompliance.vue?vue&type=script&lang=js"
export * from "./RecaptchaCompliance.vue?vue&type=script&lang=js"

import "./RecaptchaCompliance.vue?vue&type=style&index=0&id=66062b7e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66062b7e"]])

export default __exports__